import { useState } from 'react';
import Icon from './Icon';

// Drop-in replacement for `<input type="password">` with an eye toggle
// pinned to the left side (the LTR end of the field, since password values
// always render left-to-right even inside an RTL form). tabIndex=-1 keeps
// the toggle out of Tab order — Tab still moves Email → Password → Submit.
export default function PasswordInput({
  value, onChange, className, style, placeholder, autoFocus, required, minLength, id, name,
  autoComplete, onFocus, onBlur, onInvalid, onInput,
}) {
  const [show, setShow] = useState(false);
  return (
    <div style={{ position: 'relative' }}>
      <input
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        className={className}
        placeholder={placeholder}
        autoFocus={autoFocus}
        required={required}
        minLength={minLength}
        id={id}
        name={name}
        autoComplete={autoComplete}
        onFocus={onFocus}
        onBlur={onBlur}
        onInvalid={onInvalid}
        onInput={onInput}
        // paddingLeft after the spread so a caller's `padding` shorthand can't
        // collapse the space reserved for the eye toggle (text ran under it).
        style={{ ...style, paddingLeft: 44 }}
      />
      <button
        type="button"
        onClick={() => setShow(s => !s)}
        aria-label={show ? 'הסתר סיסמה' : 'הצג סיסמה'}
        title={show ? 'הסתר סיסמה' : 'הצג סיסמה'}
        tabIndex={-1}
        style={{
          position: 'absolute',
          left: 2, top: '50%', transform: 'translateY(-50%)',
          background: 'none', border: 'none', cursor: 'pointer',
          // ≥40px hit area for mobile thumbs (was ~25px and caused mis-taps)
          minWidth: 40, minHeight: 40,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: 0, opacity: 0.65, lineHeight: 1,
        }}
        onMouseEnter={e => e.currentTarget.style.opacity = '1'}
        onMouseLeave={e => e.currentTarget.style.opacity = '0.65'}
      >
        <Icon name={show ? 'eye-off' : 'eye'} size={20} strokeWidth={1.5} style={{ color: '#3F6B5C' }} />
      </button>
    </div>
  );
}
